/*  Shared  */
import { CellContext } from '@tanstack/react-table';
import { LifecyclePicker } from 'application/Shared/Components/Pickers';
import { LIFECYCLE } from 'application/Shared/Constants';

/*  React  */
import React from 'react';

import { ColumnFilter } from '../Table/types';

/**
 * Filter configuration for lifecycle cells in the table
 * Defines the default filtering options for risk-related columns
 * @type {ColumnFilter<TData>}
 */
export const lifecycleCellFilter: ColumnFilter<unknown> = {
    control: 'Checkbox',
    defaultOptions: [{ options: LIFECYCLE }]
};

export const LifecycleCell = <TData,>(props: CellContext<TData, unknown>) => {
    const { row, ...rest } = props;
    return (
        <LifecyclePicker
            // @ts-expect-error Using TData
            rerender={row.original.rerendered}
            // @ts-expect-error Using TData
            value={row.original.status}
            visualOnly
            {...rest}
        />
    );
};
